// Leesona 861 FC Winder
import React from "react";
import {
   BeginBackPressureRow, BeginTensionRow, CommonRows, GearCRow, GearDRow, GearERow,
   GearFRow, GrafRow, MinMaxRow, RunTimeRow, YardsRow
} from "./index";

export default function Machine861FC() {
   return (
      <>
         <RunTimeRow />
         <BeginBackPressureRow />
         <BeginTensionRow />
         <MinMaxRow
            titleProp={"Yarn Speed"}
            descriptionProp="ypm"
            minProp1={1}
            maxProp1={500}
            floatProp1={false}
            errorProp1={"1-500 only"}
            minProp2={1}
            maxProp2={500}
            floatProp2={false}
            errorProp2={"1-500 only"}
            valueProp1={"yarnSpeedMin"}
            valueProp2={"yarnSpeedMax"}
         />
         <GrafRow minProp={0.0} maxProp={19.9} errorProp={"0.0-19.9 only"} />
         <GearCRow minProp={10} maxProp={30} errorProp={"10-30 only"} />
         <GearDRow minProp={10} maxProp={30} errorProp={"10-30 only"} />
         <GearERow minProp={10} maxProp={30} errorProp={"10-30 only"} />
         <GearFRow minProp={10} maxProp={30} errorProp={"10-30 only"} />
         <YardsRow />
         <MinMaxRow
            titleProp={"Wind Ratio"}
            descriptionProp=""
            minProp1={1.0}
            maxProp1={12.99999}
            floatProp1={true}
            errorProp1={"1-12.99999 only"}
            minProp2={1.0}
            maxProp2={12.99999}
            floatProp2={true}
            errorProp2={"1-12.99999 only"}
            valueProp1={"windRatioStart"}
            valueProp2={"windRatioEnd"}
            differentDisplayProp1={"Start:"}
            differentDisplayProp2={"End:"}
         />
         <CommonRows />
      </>
   );
}
